import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Auth from "../../utils/AuthUtils";
import userAPI from "../../api/UserApi";
import { getTimeAgo } from "../../helper/Helper";
import {  Row, Col } from "react-bootstrap";
import { ShoppingBag, ArrowRight, Package, Sparkles } from "lucide-react"; // 🌟 Luxury icons layer

function Dashboard() {
  const { username } = Auth.getToken() || {};

  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLatestOrder();
  }, []);

  const fetchLatestOrder = async () => {
    try {
      setLoading(true);
      const res = await userAPI.fetchLatestOrder();
      if (res.code === 200) {
        setOrders(res.data);
      }
    } catch (err) {
      console.error("Dashboard tracker log matrix crack:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="orangeapes-account-dashboard-wrapper mb-5">
        <div className="orangeapes-dashboard-main-content-panel p-4 p-md-5">
          
          {/* 🌟 STAGE 1: EDITORIAL GREETING PANEL */}
          <div className="account-section-header mb-5 pb-3 border-bottom">
            <span className="orangeapes-input-micro-note-txt text-uppercase tracking-widest mb-1 d-block">
              Workspace Profile / Central Matrix
            </span>
            <h4 className="orangeapes-dashboard-main-title text-capitalize mb-2">
              Hello, {username || "Guest"}
            </h4>
            <p className="orangeapes-dashboard-subtitle mt-2">
              Today is an exceptional day to check your custom repository. Sift through your active tracking logistics pipelines, view your{" "}
              <NavLink to="/users/orders" className="orangeapes-inline-editorial-anchor">orders history</NavLink> or explore our fresh seasonal statement drops on the{" "}
              <NavLink to="/shop" className="orangeapes-inline-editorial-anchor">lookbook studio</NavLink>.
            </p>
          </div>

          {/* 🌟 STAGE 2: METRICS CARDS SLOTS GRID */}
          <div className="orangeapes-dashboard-cards-grid">
            <Row className="g-4">
              
              {/* IF ACTIVE LATEST ORDER OBJECT EXISTS */}
              {!loading && orders && (orders.orderId || orders._id) ? (
                <Col lg={6} md={12}>
                  <div className="orangeapes-dashboard-activity-card p-4 d-flex flex-column justify-content-between h-100">
                    
                    <div className="activity-card-top-row d-flex justify-content-between align-items-center mb-4">
                      <div className="d-flex align-items-center gap-2">
                        <Package size={16} className="text-orange-token" />
                        <span className="activity-card-tag-title">LATEST ORDER DROP</span>
                      </div>
                      <span className="orangeapes-status-pill-badge">{orders?.status || "Processing"}</span>
                    </div>

                    <div className="activity-card-center-data mb-4">
                      <h5 className="activity-main-identifier-text mb-2">
                        Order Registry #{orders?.orderId || orders?._id?.slice(-6).toUpperCase()}
                      </h5>
                      <div className="activity-details-meta-rows">
                        <p className="mb-1"><b>Dispatched Anchor:</b> {getTimeAgo(orders?.createdAt)}</p>
                        <p className="mb-0"><b>Total Net Cost:</b> <span>₹{orders?.total || "0"}</span></p>
                      </div>
                    </div>

                    <div className="activity-card-footer-action pt-2">
                      <Link to="/users/orders" className="orangeapes-card-arrow-trigger-link d-flex align-items-center gap-2">
                        <span>MANAGE PIPELINE LOGISTICS</span>
                        <ArrowRight size={14} className="arrow-svg-icon" />
                      </Link>
                    </div>

                  </div>
                </Col>
              ) : !loading ? (
                /* IF HANDBOOK HANDLES ZERO ORDERS ACTIVE STOCKS */
                <Col lg={6} md={12}>
                  <div className="orangeapes-dashboard-activity-card card-state-empty p-4 d-flex flex-column justify-content-between h-100">
                    <div className="activity-card-top-row d-flex align-items-center gap-2 mb-3">
                      <ShoppingBag size={16} className="text-muted" />
                      <span className="activity-card-tag-title text-muted">ORDER HISTORY HANDBOOK</span>
                    </div>
                    
                    <div className="activity-card-center-data mb-4">
                      <h5 className="activity-main-identifier-text text-muted mb-2">No Active Drops Tracked</h5>
                      <p className="orangeapes-dashboard-subtitle small">You haven't initialized any boutique checkout requests yet.</p>
                    </div>

                    <div className="activity-card-footer-action">
                      <Link to="/shop" className="orangeapes-card-arrow-trigger-link d-flex align-items-center gap-2">
                        <span>EXPLORE FRESH DISPATCHES</span>
                        <ArrowRight size={14} className="arrow-svg-icon" />
                      </Link>
                    </div>
                  </div>
                </Col>
              ) : (
                /* LOADING FRAME BLOCKS placeholder skeleton */
                <Col lg={6} md={12}>
                  <div className="text-start py-4 text-muted small">Aligning live tracking feeds...</div>
                </Col>
              )}

              {/* PERMANENT SECOND CARD SLOT: STORE NOTICES/PERKS */}
              <Col lg={6} md={12}>
                <div className="orangeapes-dashboard-activity-card studio-insider-perk-card p-4 d-flex flex-column justify-content-between h-100">
                  <div className="activity-card-top-row d-flex align-items-center gap-2 mb-4">
                    <Sparkles size={16} className="text-orange-token" />
                    <span className="activity-card-tag-title">STUDIO MEMBER INSIGHTS</span>
                  </div>

                  <div className="activity-card-center-data mb-4">
                    <h5 className="activity-main-identifier-text mb-2">Priority Whitelist Tier Active</h5>
                    <p className="orangeapes-dashboard-subtitle small">
                      Your registered account is safely synced with our centralized database nodes. Enjoy fast-track <strong>Zero-Tax calculations</strong> and priority parcel logistics dispatch filters globally.
                    </p>
                  </div>

                  <div className="activity-card-footer-action pt-2">
                    <Link to="/users/account" className="orangeapes-card-arrow-trigger-link d-flex align-items-center gap-2">
                      <span>UPDATE SPECIFICATIONS REGS</span>
                      <ArrowRight size={14} className="arrow-svg-icon" />
                    </Link>
                  </div>
                </div>
              </Col>

            </Row>
          </div>

        </div>
      </div>
    </>
  );
}

export default Dashboard;